module.exports = ace;


//////////////////
// WEBPACK FOOTER
// external "ace"
// module id = 19
// module chunks = 1